import { useCallback, useContext } from 'react';
import type { ViewModelId } from 'balus-common';
import { BookmarkedViewModelIdsContext } from '@group/contexts';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useBookmark = (
  viewModelId: ViewModelId
): {
  isBookmarked: boolean;
  toggleBookmark: () => Promise<void>;
} => {
  const { t } = useTranslation();
  const { addBookmark, removeBookmark, bookmarkedViewModelIds } = useContext(BookmarkedViewModelIdsContext);

  const isBookmarked = bookmarkedViewModelIds.has(viewModelId);

  return {
    isBookmarked,
    toggleBookmark: useCallback(async () => {
      if (isBookmarked) {
        await removeBookmark(viewModelId);
        toast(t('viewModel.bookmark.removeSuccess'));
      } else {
        await addBookmark(viewModelId);
        toast(t('viewModel.bookmark.addSuccess'));
      }
    }, [isBookmarked, viewModelId, addBookmark, removeBookmark, t]),
  };
};
